export default __webpack_public_path__ + "static/media/Advanced Potion Making - Spells_05.68e47cd9.jpg";